<form
  class="contacts-form"
  [ngClass]="{ 'contacts-form--page': pageMode }"
  [formGroup]="contactsForm"
  (ngSubmit)="onSubmit()"
>
  <!-- Email -->
  <div class="contacts-form__email">
    <bmcore-input-b
      themeInputClass="theme-input__contactsBlock"
      themeInputPlaceholderClass="theme-input__contactsBlock-placeholder"
      formControlName="email"
      [title]="lg.forms.email"
      [initialValue]="''"
      [type]="'email'"
      [controlFormName]="'email'"
      [tag]="'input'"
    >
    </bmcore-input-b>
  </div>

  <!-- Name -->
  <div class="contacts-form__name">
    <bmcore-input-b
      themeInputClass="theme-input__contactsBlock"
      themeInputPlaceholderClass="theme-input__contactsBlock-placeholder"
      formControlName="name"
      [title]="lg.forms.name"
      [initialValue]="''"
      [type]="'text'"
      [controlFormName]="'name'"
      [tag]="'input'"
    >
    </bmcore-input-b>
  </div>

  <!-- Message -->
  <div class="contacts-form__message" [ngClass]="{ 'contacts-form__message--page': pageMode }">
    <bmcore-input-b
      themeInputClass="theme-input__contactsBlock"
      themeInputPlaceholderClass="theme-input__contactsBlock-placeholder"
      formControlName="message"
      [title]="lg.forms.message"
      [initialValue]="''"
      [type]="'text'"
      [controlFormName]="'message'"
      [tag]="'textarea'"
    >
    </bmcore-input-b>
  </div>

  <div class="contacts-form__btn-container" [ngClass]="{ 'contacts-form__btn-container--page': pageMode }">
    <bmcore-button
      themeBtnClass="theme-btn__contactsBlock"
      themeIconClass="theme-icon__contactsBlock"
      title="{{ lg.button.sendMessage }}"
      icon="btv-icon-comment"
      styleName="center"
      routerPath="{{ routerPath }}"
      [disabled]="isLoader"
    >
    </bmcore-button>
  </div>
</form>

@if (isLoader) {
  <bmcore-loader></bmcore-loader>
}
